<template>
  <div class="mgl-42px">
    <div class="columns has-background-white is-marginless is-vcentered border-color-select"
         v-if="ligneSansOt === false">
      <div class="column is-narrow">
        <span class="has-text-link has-text-weight-bold">
          <router-link-blank
            :to="{ name: 'c.logistique.ordre_travail-tech', params: { id: ot.id }}"
            class="lien"
            :message="ot.typeOt.libelle">
        </router-link-blank>
        </span>
      </div>
      <div class="column is-1 is-italic is-size-7">
        {{ getLibelleEtat }}
      </div>
      <div class="column is-2-desktop is-3-fullhd">
        <b-tooltip :label="ot.description"
                   class="width-100percent" position="is-right">
          <p class="ellipsis">{{ ot.description }}</p>
        </b-tooltip>
      </div>
      <div class="column is-2-fullhd is-2-desktop is-2-widescreen">
        <span v-if="ot.datePlanification">
        {{ $t('editionProjet.ligneOt.planifie', { date: getDate(ot.datePlanification) }) }}
          </span>
        <span v-else>
          {{ $t('editionProjet.ligneOt.noPlanifie') }}
        </span>
      </div>
      <div class="column is-2-fullhd is-2-desktop is-2-widescreen">
        <span v-if="ot.dateRealisation">
          {{ $t('editionProjet.ligneOt.realise', { date: getDate(ot.dateRealisation) }) }}
        </span>
        <span v-else>
          {{ $t('editionProjet.ligneOt.noRealisation') }}
        </span>
      </div>
      <div class="column is-narrow has-text-centered">
        <router-link-blank v-if="ot.fournisseur"
          :to="{ name: 'c.logistique.technicien', params: { id: ot.fournisseurId,
          sousTypeFrom: technicien }}"
          class="lien"
          :message="ot.fournisseur ? ot.fournisseur.nomCommercial : ''">
        </router-link-blank>
      </div>
      <div class="full-width column is-paddingless">
        <div class="columns is-paddingless is-marginless is-justify-content-end is-vcentered">
          <div class="column is-narrow">
            <qd-progress :value="getPercent()" type="is-success" class="width-100"></qd-progress>
          </div>
          <div class="column is-narrow width-60px">
            {{ $t('editionProjet.ligneOt.slider', { done: getNumberTaskDone(),
            total: ot.taches.length }) }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="columns has-background-white is-marginless is-vcentered border-color-select">
      <div class="column is-12 has-text-weight-bold has-text-centered">
        {{ $t('editionProjet.ligneOt.noOt') }}
      </div>
    </div>
  </div>
</template>

<script>

import formatDate from '@/services/general/formatDate';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { TIERS_SOUS_TYPE_TECHNICIEN } from '@/configuration/tiers/tiersConf';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default {
  name: 'ligneOt',
  data() {
    return {
      technicien: TIERS_SOUS_TYPE_TECHNICIEN,
    };
  },
  props: {
    ot: {
      required: false,
      type: Object,
    },
    ligneSansOt: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  methods: {
    getDate(date) {
      return formatDate(date);
    },
    getNumberTaskDone() {
      return this.ot.taches.filter((tache) => { return tache.realise; }).length;
    },
    getPercent() {
      return (this.getNumberTaskDone() * 100) / this.ot.taches.length;
    },
  },
  computed: {
    getLibelleEtat() {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === this.ot.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
  },
};
</script>

<style scoped>

</style>
